import { render, staticRenderFns } from "./busList.vue?vue&type=template&id=bef634ba&scoped=true&"
import script from "./busList.vue?vue&type=script&lang=js&"
export * from "./busList.vue?vue&type=script&lang=js&"
import style0 from "./busList.vue?vue&type=style&index=0&id=bef634ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef634ba",
  null
  
)

export default component.exports